module.exports = __webpack_public_path__ + "img/Group 1666@2x.b49c1442.png";